export const buildProviderConfig = (form: Record<string, string>) => {
  const configs = Object.keys(form).map((field) => ({
    name: field,
    value: form[field].trim(),
  }));
  configs.push({
    name: 'enableEgress',
    value: 'true',
  });
  configs.push({
    name: 'autoPublish',
    value: 'true',
  });

  return configs;
};
